// Central API service — all backend calls go through here

import axios from "axios";

// ─────────────────────────────────────────────────────────────────────────────
// IMPORTANT: Your backend response() utility wraps all payloads like this:
//   { status: "success", statusCode: 200, message: "...", output: <payload> }
// Axios adds its own .data wrapper, so the full path to your data is always:
//   res.data.output   ← for arrays and objects
// ─────────────────────────────────────────────────────────────────────────────

const BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({ baseURL: BASE_URL });

// ── Attach token to every request automatically ──
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ── Auto logout on 401 ──
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  },
);

export default api;
